import script from "./body.vue?vue&type=script&lang=ts&setup=true"
export * from "./body.vue?vue&type=script&lang=ts&setup=true"

import "./body.vue?vue&type=style&index=0&id=37eb169f&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-37eb169f"]])

export default __exports__